import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

export const remittanceConfigSection = "/remittance-config/";

export const remittanceConfigListPath = remittanceConfigSection;
export const remittanceConfigListUrl = remittanceConfigSection;

export const riderReminderUrl = (params?: any): string => {
  const riderReminderList = remittanceConfigListUrl;
  if (params === undefined) {
    return riderReminderList;
  } else {
    return urlJoin(remittanceConfigListUrl, "?" + stringifyQs(params));
  }
};
